export class RoamingPartnersModel {
  nS: string = "";
  partnersNS: string = "";
  partnersRole: any;
  ownDevices: boolean;
  partnerDevice: boolean;
  roamingPolicy: string = "";
  incomingUL: string = "";
  outgoingUL:string = "";
  incomingDL:string = "";
  outgoingDL:string = "";

  constructor(nS: string = "", partnersNS: string = "", partnersRole: any = {'fNS': true, 'sNS': true}, ownDevices: boolean = true, partnerDevice: boolean = true, roamingPolicy: string = "Unrestricted Peering", incomingUL: string = "",outgoingUL: string = "",
              incomingDL: string = "", outgoingDL: string = ""){
    this.nS = nS;
    this.partnersNS = partnersNS;
    this.partnersRole = partnersRole;
    this.ownDevices = ownDevices;
    this.partnerDevice = partnerDevice;
    this.roamingPolicy = roamingPolicy;
    this.incomingUL = incomingUL;
    this.outgoingUL = outgoingUL;
    this.incomingDL = incomingDL;
    this.outgoingDL = outgoingDL;
  }
}
